<template>
  <v-speed-dial v-model="fab" :bottom="false" :direction="direction" :open-on-hover="false" :right="false"
                :transition="transition">
  <template v-slot:activator>
    <v-btn v-model="fab" :color="colorStates[state-1]" dark small fab>
      <v-icon>{{ iconStates[state -1] }}</v-icon>
      <v-icon>close</v-icon>
    </v-btn>
  </template>
  <v-btn fab dark small @click="changeState(states.COMPLETED)" color="green">
    <v-icon>receipt</v-icon>
  </v-btn>
  <v-btn v-if="state==states.SAVED" fab dark small @click="changeState(states.SAVED)" color="indigo">
    <v-icon>save</v-icon>
  </v-btn>
  <v-btn fab dark small @click="changeState(states.ARCHIVED)" color="red">
    <v-icon>archive</v-icon>
  </v-btn>
</v-speed-dial>
</template>

<script>
import states from '@/enums/states'

export default {
  props: {
    id: [String, Number],
    state: Number,
    direction: {
      type: String,
      default: () => "left"
    }
  },
  data() {
    return {
      fab: false,
      transition: 'slide-y-reverse-transition',
      states: states,
      iconStates: ["receipt", "save", "archive"],
      colorStates: ["green", "indigo", "red"]

    }
  },
  computed: {

  },
  methods: {
    changeState(state) {
      if (this.id === 0) {
        return this.$emit("stateChanged", state)
      }

      if (this.state == state) {
        return
      }

      this.$store.dispatch('updateStateForm', {
        schema_id: this.$route.params.schemaId,
        form_id: this.id,
        state
      })
        .then(() => {
          this.$store.commit('setSnack', {
            message: this.$t('form.update.success-message'),
            color: 'success'
          })
        })
        .catch(() => {
          this.$store.commit('setSnack', {
            message: this.$t('form.update.error-message'),
            color: 'danger'
          })
        })
    }
  }


}
</script>
